import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {InstitutionAdmin} from './institution-admin.model';
import {UserManagement} from "../../user-management/user-management.model";

export const loadInstitutionAdmins = createAction(
  '[InstitutionAdmin/API] Load InstitutionAdmins',
  props<{ institutionAdmins: InstitutionAdmin[] }>()
);

export const addInstitutionAdmin = createAction(
  '[InstitutionAdmin/API] Add InstitutionAdmin',
  props<{ institutionAdmin: InstitutionAdmin }>()
);

export const upsertInstitutionAdmin = createAction(
  '[InstitutionAdmin/API] Upsert InstitutionAdmin',
  props<{ institutionAdmin: InstitutionAdmin }>()
);

export const addInstitutionAdmins = createAction(
  '[InstitutionAdmin/API] Add InstitutionAdmins',
  props<{ institutionAdmins: InstitutionAdmin[] }>()
);

export const upsertInstitutionAdmins = createAction(
  '[InstitutionAdmin/API] Upsert InstitutionAdmins',
  props<{ institutionAdmins: InstitutionAdmin[] }>()
);

export const updateInstitutionAdmin = createAction(
  '[InstitutionAdmin/API] Update InstitutionAdmin',
  props<{ institutionAdmin: Update<InstitutionAdmin> }>()
);

export const updateInstitutionAdmins = createAction(
  '[InstitutionAdmin/API] Update InstitutionAdmins',
  props<{ institutionAdmins: Update<InstitutionAdmin>[] }>()
);

export const deleteInstitutionAdmin = createAction(
  '[InstitutionAdmin/API] Delete InstitutionAdmin',
  props<{ id: string }>()
);

export const deleteInstitutionAdmins = createAction(
  '[InstitutionAdmin/API] Delete InstitutionAdmins',
  props<{ ids: string[] }>()
);

export const clearInstitutionAdmins = createAction(
  '[InstitutionAdmin/API] Clear InstitutionAdmins'
);

// CUSTOM ACTIONS
export const createInstitutionAdminstrators = createAction(
  '[InstitutionAdmin/API] Create InstitutionAdmin',
  props<{ input: any }>()
);

export const updateInstitutionAdminstrators = createAction(
  '[InstitutionAdmin/API] edit InstitutionAdmin',
  props<{ input: any }>()
);

export const activateDeactivateInstitutionAdministrator = createAction(
  '[InstitutionUser/API] ActivateDeactivate Administrator User',
  props<{profileUniqueId: string, institutionUniqueId?: string; profileType?: string }>()
)

export const getInstitutionUsers = createAction(
  '[InstitutionAdmin/API] get institution users',
  props<{ filtering: any }>()
);

export const deleteInstitutionAdminstrators = createAction(
  '[InstitutionAdmin/API] remove institution users',
  props<{ profileUniqueId: any, id: string }>()
);
